import { Injectable } from '@angular/core';
import { LogLevel } from '@prekog/common-ui';
import { AppConfig } from './app-config.model';

let loadedConfig: AppConfig | undefined;

export async function loadAppConfig(): Promise<AppConfig> {
	const response = await fetch('/assets/config.json');
	if (!response.ok) {
		throw new Error(`Failed to load runtime config: ${response.status}`);
	}
	const raw = await response.json();
	loadedConfig = parseConfig(raw);
	return loadedConfig;
}

function parseConfig(raw: Record<string, unknown>): AppConfig {
	return {
		production: raw['production'] === true || raw['production'] === 'true',
		backendConfiguratorUrl: raw['backendConfiguratorUrl'] as string,
		apiUrl: raw['apiUrl'] as string,
		downloadUrl: raw['downloadUrl'] as string,
		regeneroBaseUrl: raw['regeneroBaseUrl'] as string,
		backendAuthUrl: raw['backendAuthUrl'] as string,
		backendFileManagerUrl: raw['backendFileManagerUrl'] as string,
		apiUrlRegenero: raw['apiUrlRegenero'] as string,
		logLevel: parseLogLevel(raw['logLevel'] as string),
		logExpirationDays: Number(raw['logExpirationDays'] ?? 7),
		enableUseCaseStatusLogs: raw['enableUseCaseStatusLogs'] === true || raw['enableUseCaseStatusLogs'] === 'true',
	};
}

function parseLogLevel(value: string | undefined): LogLevel {
	if (value === undefined || value === null) return LogLevel.Warn;
	const mapping: Record<string, LogLevel> = {
		all: LogLevel.All,
		debug: LogLevel.Debug,
		info: LogLevel.Info,
		warn: LogLevel.Warn,
		error: LogLevel.Error,
		fatal: LogLevel.Fatal,
		off: LogLevel.Off,
	};
	return mapping[value.toLowerCase()] ?? LogLevel.Warn;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
	get config(): AppConfig {
		if (!loadedConfig) {
			throw new Error('AppConfig has not been loaded. Ensure loadAppConfig() is called before bootstrapping.');
		}
		return loadedConfig;
	}
}
